function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconGps = function SvgIconGps(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1120.71 1120.71",
    fill: "currentColor"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M562.15 212.61c190.99 0 345.95 158.56 345.95 349.55S753.15 908.11 562.15 908.11 212.6 753.16 212.6 562.16s158.56-349.55 349.55-349.55Z",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeMiterlimit: 14.41,
      strokeWidth: "72.06px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.11 309.81c137.66 0 247.79 115.64 247.79 253.31S700.77 810.91 563.11 810.91 309.8 700.78 309.8 563.12s115.64-253.31 253.31-253.31Z",
    style: {
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.03 562.15h176.58m695.49 0h176.58M562.15 36.03v176.58m0 695.49v176.58",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "72.06px"
    }
  }));
};
export default SvgIconGps;